import * as React from "react";
import "./RaikoToggle.scss"

interface RaikoToggleProps {
    checked: boolean;
    setChecked: (checked: boolean) => void;
    className?: string;
    id?: string;
}

const RaikoToggle: React.FC<RaikoToggleProps> = (
    {
        checked,
        setChecked,
        className = "",
        id = "status",
    }) => {
    return (
        <label className={`checkboxSwitch ${className}`} htmlFor={id}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => {
                    setChecked(e.target.checked);
                }}
            />
            <span className="toggle round"/>
        </label>
    );
};

export default RaikoToggle;